import { mainNavigationStyles } from "@insite/content-library/Widgets/Header/MainNavigation";
import baseTheme from "@insite/mobius/globals/baseTheme";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

mainNavigationStyles.menuHeight = 102;

mainNavigationStyles.container = {
    css: css`
        color: ${getColor("common.background")};
        padding: 0 16px 0 45px;
        display: flex;
        justify-content: left;
        ${({ theme }) => {
            const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
            return breakpointMediaQueries(theme, [
                css`
                   null,
                `,
                css`
                   null,
                `,
                css`
                    null,
                `,
                css`
                    padding: 0 0px 0 70px;
                `,
                css`
                    null;
                `,
            ]);
        }}
    `,
};
mainNavigationStyles.itemWrapper = {
    css: css`
        padding-right: 50px;
        ${({ theme }) => {
            const { maxWidths } = theme.breakpoints || baseTheme.breakpoints;
            return breakpointMediaQueries(theme, [
                css`
                   null,
                `,
                css`
                   null,
                `,
                css`
                    null,
                `,
                css`
                    padding-right: 25px;
                `,
                css`
                    null;
                `,
            ]);
        }}
    `,
};

mainNavigationStyles.menuItem = {
    css: css`
        span {
            color: #000 !important;
            white-space: nowrap;
            font-weight: 600;
            min-height: 101px;
            span[class^="IconWrapper"] {
                margin: -3px 0 0px 2px;
            }
        }
    `,
};

mainNavigationStyles.megaMenu = {
    transitionDuration: "short",
    contentBodyProps: {
        _height: "1200px",
        css: css`
            padding: 20px 30px;
            background: rgba(76,75,75,0.95);
            width: 100% !important;
            left: 0 !important;
        `,
    },
};

mainNavigationStyles.megaMenuHeading = {
    css: css`
        font-weight: 600;
        margin-bottom: 8px;
        span {
            color: #fff !important;
            text-transform: uppercase;
        }
        &:hover {
            span {
                color: #3394E8 !important;
            }
        }
    `,
};

mainNavigationStyles.megaMenuLink = {
    css: css`
        span {
            font-weight: 400;
            color: #fff !important;
            font-size: 12px;
        }
        &:hover {
            span {
                color: #3394E8 !important;
            }
        }
    `,
};
